// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 12 12%27%3E%3Cpath fill=%27%23666%27 d=%27M6 8L1 3h10z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#game input::selection {
    color: #fff;
    background: #000;
}

/* ==========================================
   CPI-Style Registration Form Styles
   ========================================== */

/* Base input styles for registration */
.register-input,
input[id^="register-"] {
    font-family: Arial, sans-serif;
    font-size: 16px;
    transition: all 0.2s ease;
    box-sizing: border-box;
}

/* Text inputs */
input[id^="register-"]:not(select) {
    border: 2px solid #E0E0E0;
    border-radius: 24px;
    padding: 0 50px 0 20px;
    background: #FFFFFF;
    color: #333333;
    outline: none;
}

/* Dropdown selects (DOB) */
select[id^="register-dob-"] {
    border: 2px solid #E0E0E0;
    border-radius: 12px;
    padding: 0 35px 0 15px;
    background: #FFFFFF;
    color: #333333;
    cursor: pointer;
    outline: none;
    appearance: none;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: right 12px center;
}

/* Focus states */
input[id^="register-"]:focus,
select[id^="register-dob-"]:focus {
    border-color: #3399FF;
    box-shadow: 0 0 0 3px rgba(51, 153, 255, 0.2);
}

/* Error states */
input[id^="register-"].error,
select[id^="register-dob-"].error {
    border-color: #CC0000;
    box-shadow: 0 0 0 3px rgba(204, 0, 0, 0.2);
    background-color: #FFF8F8;
}

/* Success states */
input[id^="register-"].success,
select[id^="register-dob-"].success {
    border-color: #00CC66;
    box-shadow: 0 0 0 3px rgba(0, 204, 102, 0.2);
}

/* Placeholder styling */
input[id^="register-"]::placeholder {
    color: #999999;
    font-style: normal;
}

/* Password visibility toggle positioning */
input[id^="register-"][type="password"] {
    padding-right: 50px;
}

/* Mobile responsive adjustments */
@media screen and (max-width: 768px) {
    input[id^="register-"]:not(select) {
        font-size: 14px;
        padding: 0 40px 0 15px;
    }
    
    select[id^="register-dob-"] {
        font-size: 14px;
        padding: 0 30px 0 10px;
    }
}

@media screen and (max-width: 480px) {
    input[id^="register-"]:not(select) {
        font-size: 13px;
        border-radius: 18px;
    }
    
    select[id^="register-dob-"] {
        font-size: 13px;
        border-radius: 8px;
    }
}

/* High DPI/Retina adjustments */
@media screen and (-webkit-min-device-pixel-ratio: 2),
       screen and (min-resolution: 192dpi) {
    input[id^="register-"],
    select[id^="register-dob-"] {
        border-width: 1.5px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/styles/game.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;;+CAE+C;;AAE/C,uCAAuC;AACvC;;IAEI,8BAA8B;IAC9B,eAAe;IACf,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA,gBAAgB;AAChB;IACI,yBAAyB;IACzB,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,cAAc;IACd,aAAa;AACjB;;AAEA,2BAA2B;AAC3B;IACI,yBAAyB;IACzB,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,yDAAuL;IACvL,4BAA4B;IAC5B,sCAAsC;AAC1C;;AAEA,iBAAiB;AACjB;;IAEI,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA,iBAAiB;AACjB;;IAEI,qBAAqB;IACrB,0CAA0C;IAC1C,yBAAyB;AAC7B;;AAEA,mBAAmB;AACnB;;IAEI,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA,wBAAwB;AACxB;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA,2CAA2C;AAC3C;IACI,mBAAmB;AACvB;;AAEA,kCAAkC;AAClC;IACI;QACI,eAAe;QACf,sBAAsB;IAC1B;;IAEA;QACI,eAAe;QACf,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;AACJ;;AAEA,gCAAgC;AAChC;;IAEI;;QAEI,mBAAmB;IACvB;AACJ","sourcesContent":["#game input::selection {\r\n    color: #fff;\r\n    background: #000;\r\n}\r\n\r\n/* ==========================================\r\n   CPI-Style Registration Form Styles\r\n   ========================================== */\r\n\r\n/* Base input styles for registration */\r\n.register-input,\r\ninput[id^=\"register-\"] {\r\n    font-family: Arial, sans-serif;\r\n    font-size: 16px;\r\n    transition: all 0.2s ease;\r\n    box-sizing: border-box;\r\n}\r\n\r\n/* Text inputs */\r\ninput[id^=\"register-\"]:not(select) {\r\n    border: 2px solid #E0E0E0;\r\n    border-radius: 24px;\r\n    padding: 0 50px 0 20px;\r\n    background: #FFFFFF;\r\n    color: #333333;\r\n    outline: none;\r\n}\r\n\r\n/* Dropdown selects (DOB) */\r\nselect[id^=\"register-dob-\"] {\r\n    border: 2px solid #E0E0E0;\r\n    border-radius: 12px;\r\n    padding: 0 35px 0 15px;\r\n    background: #FFFFFF;\r\n    color: #333333;\r\n    cursor: pointer;\r\n    outline: none;\r\n    appearance: none;\r\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23666' d='M6 8L1 3h10z'/%3E%3C/svg%3E\");\r\n    background-repeat: no-repeat;\r\n    background-position: right 12px center;\r\n}\r\n\r\n/* Focus states */\r\ninput[id^=\"register-\"]:focus,\r\nselect[id^=\"register-dob-\"]:focus {\r\n    border-color: #3399FF;\r\n    box-shadow: 0 0 0 3px rgba(51, 153, 255, 0.2);\r\n}\r\n\r\n/* Error states */\r\ninput[id^=\"register-\"].error,\r\nselect[id^=\"register-dob-\"].error {\r\n    border-color: #CC0000;\r\n    box-shadow: 0 0 0 3px rgba(204, 0, 0, 0.2);\r\n    background-color: #FFF8F8;\r\n}\r\n\r\n/* Success states */\r\ninput[id^=\"register-\"].success,\r\nselect[id^=\"register-dob-\"].success {\r\n    border-color: #00CC66;\r\n    box-shadow: 0 0 0 3px rgba(0, 204, 102, 0.2);\r\n}\r\n\r\n/* Placeholder styling */\r\ninput[id^=\"register-\"]::placeholder {\r\n    color: #999999;\r\n    font-style: normal;\r\n}\r\n\r\n/* Password visibility toggle positioning */\r\ninput[id^=\"register-\"][type=\"password\"] {\r\n    padding-right: 50px;\r\n}\r\n\r\n/* Mobile responsive adjustments */\r\n@media screen and (max-width: 768px) {\r\n    input[id^=\"register-\"]:not(select) {\r\n        font-size: 14px;\r\n        padding: 0 40px 0 15px;\r\n    }\r\n    \r\n    select[id^=\"register-dob-\"] {\r\n        font-size: 14px;\r\n        padding: 0 30px 0 10px;\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 480px) {\r\n    input[id^=\"register-\"]:not(select) {\r\n        font-size: 13px;\r\n        border-radius: 18px;\r\n    }\r\n    \r\n    select[id^=\"register-dob-\"] {\r\n        font-size: 13px;\r\n        border-radius: 8px;\r\n    }\r\n}\r\n\r\n/* High DPI/Retina adjustments */\r\n@media screen and (-webkit-min-device-pixel-ratio: 2),\r\n       screen and (min-resolution: 192dpi) {\r\n    input[id^=\"register-\"],\r\n    select[id^=\"register-dob-\"] {\r\n        border-width: 1.5px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
